export const Validatorsforms ={
    email: new RegExp ('[a-zA-Z0-9_]+([.\-][a-zA-Z0-9_]+)*@[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)*[.][a-zA-Z]{2,5}')
}